export default __webpack_public_path__ + "static/media/mb.d19b2d29.svg";